import { PaginationQuery } from "../../types";
import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { InsertScrewBody, SearchScrewsResponse, UpdateScrewBody } from "./types/screws";
import { SCREW_CONNECTOR_ADMIN_URL } from "./screwConnectorAdminUrl";
import { SCREW_CONNECTOR_URL } from "./screwConnectorUrl";

// Keyed by its item id. Visibility and order go through the full update (no /visibility nor /order endpoints).
export const useScrewConnectorScrewsApi = () => {
  // The calculator reads the screws too.
  const crud = createAdminCrudApi<SearchScrewsResponse, InsertScrewBody, UpdateScrewBody>(
    useApi(),
    SCREW_CONNECTOR_ADMIN_URL,
    "screws",
    [SCREW_CONNECTOR_URL],
  );

  return {
    useScrews: (query: PaginationQuery, signal: AbortSignal, screwDiameterId?: string) =>
      crud.useSearch(query, signal, { screwDiameterId }),
    insertScrew: crud.insert,
    updateScrew: crud.update,
    deleteScrew: crud.remove,
  };
};

export default useScrewConnectorScrewsApi;
